let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lnfJP")).then(() => parcelRequire('TOAHd'));